import forEach from "lodash/forEach";
import moment from "../../../../moment";
import config from "../../../../config";
import { REPORT_FORM_TYPE } from "../index";
import axios from "../../../../axios";
import { openNotification } from "../../../../components/Notification";
import { prepareFormData } from "./reportFormData";

export { prepareFormData } from "./reportFormData";

export const getFormInitialValues = (values, format, loggedUser, type, t) => {
  const safeValues = values || {};
  const { basic_data, investigation } = safeValues;

  const event_date = basic_data?.event_date ? basic_data.event_date : "";
  const event_time = basic_data?.event_time ? basic_data.event_time : "00:00";

  const eventFullDate = event_date + " " + event_time;

  return {
    ...safeValues,
    basic_data: {
      ...basic_data,
      reporter_id: basic_data?.reporter_id || t("ior.new_report.anonymous"),
      ...(type === REPORT_FORM_TYPE.NEW && { reporter_id: loggedUser.id, stage: "new" }),
      event_date: event_date
        ? format({ date: eventFullDate, dateFormat: config.defaultDateFormat, defaultReturn: null })
        : null,
      event_time: basic_data?.event_time ? moment(basic_data.event_time, "HH:mm") : undefined
    },
    investigation: {
      ...investigation,
      tags: safeValues.tags?.map((item) => item.id) || undefined
    }
  };
};

export const prepareFields = (type, fields = []) => {
  return fields.map((item) => {
    if (type === REPORT_FORM_TYPE.VIEW) {
      item.required = false;
      item.placeholder = "";
      item.fieldProps = { ...item.fieldProps, disabled: true };
    }
    return item;
  });
};

export const showCollapsedBoxErrors = (form, errors, collapseErrors, setCollapseErrors) => {
  const collapseItems = { ...collapseErrors };
  forEach(collapseItems, (value, key) => {
    collapseItems[key] = false;
  });
  let errorFieldElement;
  const formErrors = errors.map((err) => {
    const namesArray = err.name.split(".");
    collapseItems[namesArray[0]] = true;

    if (!errorFieldElement) {
      errorFieldElement = document.getElementById(namesArray.join("_"));
    }

    err.name = namesArray;
    return err;
  });

  if (formErrors?.length > 0) {
    setCollapseErrors(collapseItems);
    form.setFields(formErrors);
    errorFieldElement &&
      window.scrollTo({
        top: errorFieldElement.closest(".ant-collapse").getBoundingClientRect().top - 80,
        behavior: "smooth"
      });
  }
};

export const saveSectionData = ({
  form,
  data,
  setLoading,
  formatLocaleUTC,
  format,
  successMessage,
  errorMessage,
  setBasicDataSaved = null
}) => {
  const values = form.getFieldsValue([
    "basic_data",
    "basic_files",
    "investigation",
    "first_risk_analysis",
    "second_risk_analysis",
    "management_summary"
  ]);
  setLoading(true);
  const id = data?.basic_data?.id;
  const request = id
    ? axios.put(`ior/report/${id}`, prepareFormData(values, formatLocaleUTC, format, []))
    : axios.post("ior/report", prepareFormData(values, formatLocaleUTC, format, []));
  request.then(
    (response) => {
      setLoading(false);
      openNotification({ message: successMessage, type: "success", placement: "bottom" });
      if (setBasicDataSaved) setBasicDataSaved(response.data.data);
    },
    () => {
      setLoading(false);
      openNotification({ message: errorMessage, type: "error", placement: "bottom" });
    }
  );
};
